import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { i18n } from '../../../i18n/translate.js';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil.js';
import { Modal } from '../../../core/components/Modal/component.js';
import Button from '../../../core/components/Button/component.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Icon } from '../../../core/components/Icon/component.js';
var LanguageModalBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var buttonDisabled = _ref.buttonDisabled,
      confirmSelection = _ref.confirmSelection,
      enforceSelection = _ref.enforceSelection,
      languages = _ref.languages,
      onClose = _ref.onClose,
      renderedTitle = _ref.renderedTitle,
      selected = _ref.selected,
      setSelected = _ref.setSelected,
      showLanguageModal = _ref.showLanguageModal;
  return /*#__PURE__*/React.createElement(Modal // @ts-ignore
  , {
    ref: ref,
    isCentered: true,
    isOpen: showLanguageModal,
    modalType: 'modal',
    onClose: onClose,
    showCloseButton: !enforceSelection,
    variant: 'default',
    header: renderedTitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: 'secondary'
    }, i18n.t('Cancel')), /*#__PURE__*/React.createElement(Button, {
      isDisabled: buttonDisabled,
      onClick: confirmSelection,
      variant: 'primary'
    }, i18n.t('Save')))
  }, /*#__PURE__*/React.createElement(Layout, {
    "data-object-type": "language-modal-body"
  }, Object.entries(languages).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        code = _ref3[0],
        native_name = _ref3[1].native_name;

    var isSelected = selected === code;
    return /*#__PURE__*/React.createElement(Layout, {
      "aria-pressed": isSelected,
      key: code,
      lang: code,
      onClick: function onClick() {
        return setSelected(code);
      },
      onKeyDown: onExecuteKeyDown(function () {
        return setSelected(code);
      }),
      role: "button",
      tabIndex: -1,
      "data-object-type": "languages",
      "data-object-id": code,
      "data-selected": isSelected
    }, native_name, isSelected && /*#__PURE__*/React.createElement(Layout, {
      as: 'span',
      ml: 'xs',
      color: 'icon-brand'
    }, /*#__PURE__*/React.createElement(Icon, {
      iconName: 'check'
    })));
  })));
});
LanguageModalBody.displayName = 'LanguageModalBody';
export { LanguageModalBody };